import { ROLE_FACILITATOR, setStoredRole } from '../../../utils/authRole';
import useStore from '../../../customHooks/useStore';

export const completeAdminLogin = ({
  context,
  history,
  token,
  name,
  initialVideo = false,
  showExplain = false,
  program = 'EZP',
  role = ROLE_FACILITATOR,
}) => {
  useStore.getState().setLanguage('en');
  localStorage.setItem('name', name);
  localStorage.setItem('initialVideo', String(initialVideo));
  localStorage.setItem('showExplain', String(showExplain === true));
  localStorage.setItem('program', program);
  setStoredRole(role);
  context.login(token, false, { skipBootstrap: true });
  context.setIsAdmin(true, program);
  history.push('/facilitator/home');
};
